export const parsePropByType = (prop, type) => {
  switch (type) {
    case 'number':
      return Number(prop);
    case 'boolean':
      return Boolean(prop);
    case 'booleanString':
      return JSON.parse(prop);
    case 'array':
      return Array.isArray(prop) ? prop : [prop];
    default:
      return prop;
  }
};
